import React from 'react';
import CommonProductSelection from 'src/constrains/AdvancedFilters/Components/CommonStoreProductsWithTable';

const ProductsPurchased = (props) => {
  const { noStyle, radioName, listName, id, onClear, hasExclude, disabled } =
    props;
  return (
    <CommonProductSelection
      hasExclude={hasExclude}
      noStyle={noStyle}
      radioName={radioName}
      listName={listName}
      id={id}
      // onReselect={onReselect}
      onClear={onClear}
      disabled={disabled}
    />
  );
};
export default ProductsPurchased;
